import {CommonBuildConfigurationInput as BuildConfigurationInput} from '../commonConfiguration.types'

import {MixCharacteristicsConfiguration} from './types'

export const buildMixCharacteristicsConfiguration = ({
  options
}: BuildConfigurationInput): MixCharacteristicsConfiguration => {
  // Mix characteristics are enabled if there are any materials with variations available
  // This will be determined by the presence of materialVariations in the contracts/materials
  const isEnabled = options.contracts.some((contract) =>
    contract.materials.some((material) => material.materialVariations !== null && material.materialVariations !== undefined)
  )

  return {
    mixCharacteristics: {
      isEnabled
    }
  }
}
